import { render, staticRenderFns } from "./GeRen.vue?vue&type=template&id=db140ff8"
import script from "./GeRen.vue?vue&type=script&lang=js"
export * from "./GeRen.vue?vue&type=script&lang=js"
import style0 from "./GeRen.vue?vue&type=style&index=0&id=db140ff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports